import { render, staticRenderFns } from "./cdrByOperadora.vue?vue&type=template&id=4594a588&"
import script from "./cdrByOperadora.vue?vue&type=script&lang=js&"
export * from "./cdrByOperadora.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports